module.exports = __webpack_public_path__ + "img/pending.de721b0b.png";